<template>
  <b-card v-if="isPermitted('seeHotAlert')">

    <div>
      <b-row>
        <!-- Project -->
        <b-col>
          <v-select
            id="vue-select-project"
            v-model="selectedProject"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionProject"
            :reduce="project => project.id"
            label="projectName"
            :placeholder="$t('All projects')"
            :clearable="false"
            class="mb-2"
          />
        </b-col>
        <!-- Period start -->
        <b-col
          md="2"
        >
          <v-select
            v-if="selectedProject"
            id="vue-select-period-start"
            v-model="selectedPeriodStart"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionProjectPeriods"
            :clearable="false"
            class="mb-2"
          />

        </b-col>
        <!-- Period end -->
        <b-col
          md="2"
        >
          <v-select
            v-if="selectedProject"
            id="vue-select-period-end"
            v-model="selectedPeriodEnd"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionProjectPeriods"
            :clearable="false"
            class="mb-2"
          />
        </b-col>
        <b-col
          md="2"
        >
          <b-button
            class="w-100"
            :variant="appliedFilter && appliedFilter.filters.length?'success':'secondary'"
            @click="hotalertFilter"
          >
            {{ $t('Advanced Filter') }}
          </b-button>
        </b-col>
      </b-row>

      <b-row v-if="appliedFilter && appliedFilter.filters.length">
        <b-col>
          <b-card>
            <span
              v-for="(filterItem,index) in appliedFilter.filters"
              :key="index"
            >
              <template v-if="filterItem.operator">
                {{ filterItem.operator }}
              </template>
              <template v-else>
                <strong class="mr-1">{{ filterItem.filterQuestion.questionText }} = </strong>
                <b-badge
                  v-for="(value,idx) in filterItem.filterValues"
                  :key="idx"
                  variant="primary"
                >{{ value.optionText }}</b-badge>
                <b-badge
                  v-for="(value,idx) in filterItem.filterValuesText"
                  :key="idx"
                  variant="primary"
                >{{ value }}</b-badge>
              </template>
            </span>

          </b-card>

        </b-col>
      </b-row>

      <b-tabs
        v-model="tabIndex"
      >
        <b-tab :title="$t('List')">
          <b-row>

            <b-col
              v-for="(data,index) in statslist"
              :key="index"
              :md="index===0?12:6"
              :xl="index===0?12:3"
            >
              <b-card
                :bg-variant="selectedStat===data.subtitle||selectedStat==='All Hotalerts'||!selectedStat?data.color:'secondary'"
                text-variant="white"
                class="text-center"
                style="cursor:pointer"
                @click="selectedStat!==data.subtitle?selectedStat=data.subtitle:selectedStat='All Hotalerts'"
              >
                <b-card-text
                  style="font-size:large"
                  class="mt-2 mb-0"
                >
                  {{ $t(data.subtitle) }}
                </b-card-text>
                <b-card-title
                  class="text-white mb-2"
                  style="font-size:xx-large"
                >
                  {{ data.title }}
                </b-card-title>
              </b-card>
            </b-col>
          </b-row>

          <b-form
            inline
            class="mb-2"
          >

            <b-form-input
              v-model="searchTerm"
              :placeholder=" $t('message.SearchPlaceholder')"
              type="text"
              class="d-inline mt-1"
            />

            <b-link
              class="ml-2 mt-1"
              @click="downloadHotAlerts"
            >
              Download
            </b-link>

          </b-form>

          <!-- table -->
          <vue-good-table
            style-class="vgt-table striped"
            :columns="columns"
            :rows="rows"
            :sort-options="{
              enabled: true,
              initialSortBy: {field: 'id', type: 'desc'}
            }"
            :search-options="{
              enabled: true,
              externalQuery: searchTerm }"
            :select-options="{
              enabled: false,
              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
              disableSelectInfo: true, // disable the select info panel on top
            }"
            :pagination-options="{
              enabled: true,
              perPage:pageLength,
              mode: 'records',
              perPage: 10,
              perPageDropdown: [10, 50, 100],
              dropdownAllowAll: false,
            }"
          >
            <template
              slot="table-column"
              slot-scope="props"
            >
              <span>
                {{ $t(props.column.label) }}
              </span>
            </template>

            <template
              slot="table-row"
              slot-scope="props"
            >

              <!-- Column: OrjRef -->
              <span
                v-if="props.column.field === 'orjref'"
                class="text-nowrap"
              >
                <b-link @click="view(props.row)">
                  {{ props.row.orjref }}
                </b-link>
              </span>

              <!-- Column: createDate -->
              <span
                v-else-if="props.column.field === 'createdate'"
                class="text-nowrap"
              >
                {{ formatDate(props.row.createdate) }}
              </span>
              <!-- Column: contactDate -->
              <span
                v-else-if="props.column.field === 'contactdate'"
                class="text-nowrap"
              >
                {{ props.row.contactdate ? formatDate(props.row.contactdate) : '-' }}
              </span>
              <!-- Column: closedat -->
              <span
                v-else-if="props.column.field === 'closedat'"
                class="text-nowrap"
              >
                <template v-if="props.row.status==='Closed'">{{ formatDate(props.row.closedat) }}</template>
                <template v-else />

              </span>

              <!-- Column: assignedDate -->
              <span
                v-else-if="props.column.field === 'assigneddate'"
                class="text-nowrap"
              >
                {{ props.row.assigneddate?formatDate(props.row.assigneddate):'-' }}
              </span>

              <!-- Column: actionTakenDate -->
              <span
                v-else-if="props.column.field === 'actiontakendate'"
                class="text-nowrap"
              >
                {{ props.row.actiontakendate?formatDate(props.row.actiontakendate):'-' }}
              </span>

              <!-- Column: categories -->
              <span
                v-else-if="props.column.field === 'categories'"
                class="text-nowrap"
              >
                {{ (props.row.categories && props.row.categories.length) ? String(props.row.categories).split('|').join('/') : '' }}
              </span>

              <!-- Column: Common -->
              <span v-else>
                {{ $t(props.formattedRow[props.column.field]) }}
              </span>
            </template>

          </vue-good-table>

        </b-tab>
        <b-tab :title="$t('Analysis')">
          <!-- Analysis Table -->
          <b-row>
            <b-col>
              <b-card>
                <table
                  v-if="analysisResults.length"
                  class="table table-striped"
                >
                  <thead>
                    <tr>
                      <th class="text-left">
                        {{ $t('Category') }}
                      </th>
                      <th class="text-center">
                        {{ $t('Total Survey Count') }}
                      </th>
                      <th class="text-center">
                        {{ $t('Total Hot Alert Count') }}
                      </th>
                      <th class="text-center">
                        {{ $t('Hot Alert Percentage') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(analysis, index) in analysisResults"
                      :key="index"
                    >
                      <td class="text-left">
                        {{ analysis.category }}
                      </td>
                      <td class="text-center">
                        {{ analysis.dataCount }}
                      </td>
                      <td class="text-center">
                        {{ analysis.hotAlertCount }}
                      </td>
                      <td class="text-center">
                        {{ (analysis.hotAlertCount / analysis.dataCount * 100).toFixed(2) }}%
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-card>
            </b-col>
          </b-row>

          <!-- Charts Section -->
          <b-row class="mb-4">
            <!-- Status Pie Chart -->
            <b-col md="6">
              <b-card>
                <h4 class="mb-3 text-center">
                  {{ $t('Hot Alert Status') }}
                </h4>
                <highcharts
                  v-if="statusChartOptions"
                  :options="statusChartOptions"
                />
              </b-card>
            </b-col>

            <!-- Contact Status Pie Chart -->
            <b-col md="6">
              <b-card>
                <h4 class="mb-3 text-center">
                  {{ $t('Contact Status') }}
                </h4>
                <highcharts
                  v-if="contactStatusChartOptions"
                  :options="contactStatusChartOptions"
                />
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mb-4">
            <!-- Action Taken Bar Chart -->
            <b-col md="6">
              <b-card>
                <h4 class="mb-3 text-center">
                  {{ $t('Action Taken') }}
                </h4>
                <highcharts
                  v-if="actionChartOptions"
                  :options="actionChartOptions"
                />
              </b-card>
            </b-col>

            <!-- Categories Bar Chart -->
            <b-col md="6">
              <b-card>
                <h4 class="mb-3 text-center">
                  {{ $t('Categories') }}
                </h4>
                <highcharts
                  v-if="categoriesChartOptions"
                  :options="categoriesChartOptions"
                />
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>

      <modal-hot-alert @refreshHotalertList="loadData,loadAnalysis" />
      <modal-hot-alert-filter
        v-if="selectedProject"
        v-model="filterConfig"
        :project-id="selectedProject"
        @refreshHotalertList="setFilter"
      />

    </div>
  </b-card>
</template>

<script>

import { getUserData, isPermitted } from '@/auth/utils'
import useJwt from '@/auth/jwt/useJwt'
import { VueGoodTable } from 'vue-good-table'
import vSelect from 'vue-select'
import {
  BCard, BForm, BFormInput, BLink, BRow, BCol, BCardText, BCardTitle, BButton, BBadge, BTabs, BTab,
} from 'bootstrap-vue'
import ModalHotAlert from '@/layouts/components/ModalHotAlert.vue'
import ModalHotAlertFilter from '@/layouts/components/ModalHotAlertFilter.vue'
import dayjs from 'dayjs'
import { Chart } from 'highcharts-vue'

export default {
  components: {
    vSelect,
    BCard,
    BCardText,
    BCardTitle,
    BForm,
    BFormInput,
    BRow,
    BCol,
    BLink,
    BButton,
    BBadge,
    BTabs,
    BTab,
    VueGoodTable,
    ModalHotAlert,
    ModalHotAlertFilter,
    highcharts: Chart,
  },
  data() {
    return {
      selectedStat: 'All Hotalerts',
      tabIndex: 0,
      pageLength: 10,
      listColumns: [],
      rows: [],
      searchTerm: '',
      preColumns: [
        {
          label: '#',
          field: 'id',
          type: 'number',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '50px',
        },
        {
          label: 'Survey Id',
          field: 'orjref',
          type: 'number',
        },
        {
          label: 'Create Date',
          field: 'createdate',
        },
        {
          label: 'Hot Alert Reason',
          field: 'hotalertreason',
        },
        {
          label: 'Assigned To',
          field: 'assignedto',
        },
        {
          label: 'Assigned Date',
          field: 'assigneddate',
        },
      ],
      postColumns: [
        {
          label: 'Action Taken',
          field: 'actiontaken',
        },
        {
          label: 'Action Taken Description',
          field: 'actiontakendescription',
        },
        {
          label: 'Contact Status',
          field: 'contactstatus',
        },
        {
          label: 'Contact Date',
          field: 'contactdate',
        },
        {
          label: 'Closed At',
          field: 'closedat',
        },
        {
          label: 'Categories',
          field: 'categories',
        },
        {
          label: 'Status',
          field: 'status',
        },
      ],
      columns: [],
      stats: [],
      selectedProject: null,
      optionProject: [],
      optionProjectPeriods: [],
      selectedPeriodStart: null,
      selectedPeriodEnd: null,
      filterConfig: { filters: [] },
      appliedFilter: { filters: [] },
      analysisResults: [],
      analysisResultsStatus: [],
      analysisResultsContactStatus: [],
      analysisResultsAction: [],
      analysisResultsCategories: [],
    }
  },
  computed: {
    statslist() {
      if (this.stats) {
        const arr = []
        this.stats.forEach(x => {
          arr.push({
            icon: (x.status.replace('All Hotalerts', 'BellIcon').replace('Assigned', 'UserCheckIcon').replace('Unassigned', 'InfoIcon').replace('Closed', 'CheckCircleIcon')
              .replace('Overdue', 'AlertTriangleIcon')),
            color: (x.status.replace('All Hotalerts', 'danger').replace('Assigned', 'info').replace('Unassigned', 'warning').replace('Closed', 'success')
              .replace('Overdue', 'danger')),
            title: x.statusCount,
            subtitle: x.status,
            size: 12 / this.stats.length,
            customClass: '',
          })
        })
        return arr
      }
      return null
    },
    statusChartOptions() {
      if (!this.analysisResultsStatus || !this.analysisResultsStatus.length) return null

      // Color mapping for status
      const statusColors = {
        Overdue: '#ea5455', // Gunu gecen
        Unassigned: '#ff9f43', // Yeni
        Assigned: '#00cfe8', // Surec Devam Ediyor
        Closed: '#28c76f', // Kapanan
      }

      // Filter out items with 0 count for cleaner visualization
      const data = this.analysisResultsStatus
        .filter(item => item.statusCount > 0)
        .map(item => ({
          name: this.$t(item.status || 'Unknown'),
          y: item.statusCount || 0,
          color: statusColors[item.status] || null,
        }))

      if (data.length === 0) return null

      return {
        chart: {
          type: 'pie',
          height: 400,
        },
        title: {
          text: '',
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y}</b> ({point.percentage:.1f}%)',
        },
        accessibility: {
          point: {
            valueSuffix: '%',
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y} ({point.percentage:.1f}%)',
            },
            showInLegend: true,
          },
        },
        series: [{
          name: 'Count',
          colorByPoint: true,
          data,
        }],
        credits: {
          enabled: false,
        },
      }
    },
    contactStatusChartOptions() {
      if (!this.analysisResultsContactStatus || !this.analysisResultsContactStatus.length) return null

      // Color mapping for contact status
      const contactStatusColors = {
        'Müşteri ile görüşüldü': '#28c76f',
        'Müşteri arandı ancak ulaşılamadı': '#00cfe8',
        'Müşteri aranmadı': '#ea5455',
      }

      // Try to detect the correct field name (could be 'count', 'contactStatusCount', etc.)
      const firstItem = this.analysisResultsContactStatus[0]
      let countField = 'count'
      if (firstItem.contactStatusCount !== undefined) {
        countField = 'contactStatusCount'
      } else if (firstItem.count !== undefined) {
        countField = 'count'
      } else if (firstItem.statusCount !== undefined) {
        countField = 'statusCount'
      }

      const nameField = firstItem.contactStatus !== undefined ? 'contactStatus' : 'status'

      const data = this.analysisResultsContactStatus
        .filter(item => item[countField] > 0)
        .map(item => ({
          name: this.$t(item[nameField] || 'Unknown'),
          y: item[countField] || 0,
          color: contactStatusColors[item[nameField]] || null,
        }))

      if (data.length === 0) return null

      return {
        chart: {
          type: 'pie',
          height: 400,
        },
        title: {
          text: '',
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y}</b> ({point.percentage:.1f}%)',
        },
        accessibility: {
          point: {
            valueSuffix: '%',
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y} ({point.percentage:.1f}%)',
            },
            showInLegend: true,
          },
        },
        series: [{
          name: 'Count',
          colorByPoint: true,
          data,
        }],
        credits: {
          enabled: false,
        },
      }
    },
    actionChartOptions() {
      if (!this.analysisResultsAction || !this.analysisResultsAction.length) return null

      // Try to detect the correct field names
      const firstItem = this.analysisResultsAction[0]
      let countField = 'statusCount'
      if (firstItem.statusCount !== undefined) {
        countField = 'statusCount'
      } else if (firstItem.actionCount !== undefined) {
        countField = 'actionCount'
      } else if (firstItem.count !== undefined) {
        countField = 'count'
      } else if (firstItem.actionTakenCount !== undefined) {
        countField = 'actionTakenCount'
      }

      let nameField = 'status'
      if (firstItem.status !== undefined) {
        nameField = 'status'
      } else if (firstItem.actionTaken !== undefined) {
        nameField = 'actionTaken'
      } else if (firstItem.action !== undefined) {
        nameField = 'action'
      }

      const categories = this.analysisResultsAction.map(item => this.$t(item[nameField] || 'Unknown'))
      const rawData = this.analysisResultsAction.map(item => item[countField] || 0)
      const total = rawData.reduce((sum, value) => sum + value, 0)
      const data = rawData.map(value => (total > 0 ? ((value / total) * 100) : 0))

      return {
        chart: {
          type: 'bar',
          height: Math.max(400, categories.length * 40),
        },
        colors: ['#28c76f'],
        title: {
          text: '',
        },
        xAxis: {
          categories,
          title: {
            text: '',
          },
        },
        yAxis: {
          min: 0,
          max: 100,
          labels: {
            overflow: 'justify',
            format: '{value}%',
          },
          title: {
            text: '',
          },
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:.1f}%</b>',
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              format: '{point.y:.1f}%',
            },
          },
        },
        legend: {
          enabled: false,
        },
        series: [{
          name: this.$t('Action Taken'),
          data,
        }],
        credits: {
          enabled: false,
        },
      }
    },
    categoriesChartOptions() {
      if (!this.analysisResultsCategories || !this.analysisResultsCategories.length) return null

      // Try to detect the correct field names
      const firstItem = this.analysisResultsCategories[0]
      let countField = 'statusCount'
      if (firstItem.statusCount !== undefined) {
        countField = 'statusCount'
      } else if (firstItem.categoryCount !== undefined) {
        countField = 'categoryCount'
      } else if (firstItem.count !== undefined) {
        countField = 'count'
      } else if (firstItem.categoriesCount !== undefined) {
        countField = 'categoriesCount'
      }

      let nameField = 'status'
      if (firstItem.status !== undefined) {
        nameField = 'status'
      } else if (firstItem.category !== undefined) {
        nameField = 'category'
      } else if (firstItem.categories !== undefined) {
        nameField = 'categories'
      }

      const categories = this.analysisResultsCategories.map(item => this.$t(item[nameField] || 'Unknown'))
      const rawData = this.analysisResultsCategories.map(item => item[countField] || 0)
      const total = rawData.reduce((sum, value) => sum + value, 0)
      const data = rawData.map(value => (total > 0 ? ((value / total) * 100) : 0))

      return {
        chart: {
          type: 'bar',
          height: Math.max(400, categories.length * 40),
        },
        colors: ['#00cfe8'],
        title: {
          text: '',
        },
        xAxis: {
          categories,
          title: {
            text: null,
          },
        },
        yAxis: {
          min: 0,
          max: 100,
          labels: {
            overflow: 'justify',
            format: '{value}%',
          },
          title: {
            text: '',
          },
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:.1f}%</b>',
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              format: '{point.y:.1f}%',
            },
          },
        },
        legend: {
          enabled: false,
        },
        series: [{
          name: this.$t('Categories'),
          data,
        }],
        credits: {
          enabled: false,
        },
      }
    },
  },
  watch: {
    selectedProject() {
      this.getProjectPeriodOptions()
    },
    selectedPeriodStart() {
      this.loadData()
      this.loadAnalysis()
    },
    selectedPeriodEnd() {
      this.loadData()
      this.loadAnalysis()
    },
    selectedStat() {
      this.loadData()
      this.loadAnalysis()
    },
  },
  created() {
    this.userData = getUserData()
    this.getProjectOptions()
  },
  methods: {
    isPermitted(code) {
      if (!this.userData) {
        return false
      }
      return isPermitted(this.userData.role, code, this.userData.userGroups)
    },
    view(item) {
      console.log(item)
      this.$root.$emit('view_hotalert', item)
    },
    getProjectOptions() {
      useJwt.axiosIns.get('project').then(response => {
        this.optionProject = response.data.filter(p => p.status)
        if (this.optionProject.length) {
          this.selectedProject = this.optionProject[0].id
          this.getProjectPeriodOptions()
        }
      })
    },
    getProjectPeriodOptions() {
      useJwt.axiosIns.get(`project/${this.selectedProject}/wavelist`).then(response => {
        this.optionProjectPeriods = response.data.sort((a, b) => b - a)
        if (response.data) {
          // eslint-disable-next-line prefer-destructuring
          this.selectedPeriodEnd = response.data[0]
          // this.selectedPeriodStart = response.data[response.data.length - 1]
          this.selectedPeriodStart = this.selectedPeriodEnd
        }
      })
    },
    formatDate(date) {
      return dayjs(date).format('DD.MM.YYYY HH:mm:ss')
    },
    downloadHotAlerts() {
      useJwt.axiosIns.post(`hotalert/project/${this.selectedProject}/exportxlsx/${this.$i18n.locale}/${this.selectedPeriodStart}/${this.selectedPeriodEnd}/${this.selectedStat}`, this.appliedFilter, { responseType: 'arraybuffer' })
        .then(response => {
          if (response) {
            this.openFile(response, 'hotalerts.xlsx')
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    openFile(response, filename) {
      const type = response.headers['content-type']
      const blob = new Blob([response.data], {
        type,
        encoding: 'UTF-8',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      link.remove()
    },
    loadData() {
      if (this.selectedProject && this.selectedPeriodStart && this.selectedPeriodEnd) {
        this.columns = []
        useJwt.axiosIns.get(`hotalert/project/${this.selectedProject}/hotalertcolumns`)
          .then(response => {
            if (response.data) {
              this.listColumns = response.data
            }

            useJwt.axiosIns.post(`hotalert/project/${this.selectedProject}/${this.selectedPeriodStart}/${this.selectedPeriodEnd}/${this.selectedStat}`, this.appliedFilter)
              .then(response2 => {
                if (response2.data) {
                  this.rows = response2.data
                  this.columns = [...this.preColumns, ...this.listColumns.map(x => ({ label: x.questionText, field: x.questionName })), ...this.postColumns]
                }
              })
              .catch(e => {
                console.log(e)
              })
          })
          .catch(e => {
            console.log(e)
          })

        useJwt.axiosIns.post(`hotalert/stats/${this.selectedProject}/${this.selectedPeriodStart}/${this.selectedPeriodEnd}`, this.appliedFilter)
          .then(response => {
            if (response.data) {
              this.stats = response.data
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    loadAnalysis() {
      // Table
      useJwt.axiosIns.post(`hotalert/analysis/${this.selectedProject}/${this.selectedPeriodStart}/${this.selectedPeriodEnd}`, this.appliedFilter)
        .then(response => {
          if (response.data) {
            this.analysisResults = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })

      // Status
      useJwt.axiosIns.post(`hotalert/analysis/status/${this.selectedProject}/${this.selectedPeriodStart}/${this.selectedPeriodEnd}`, this.appliedFilter)
        .then(response => {
          if (response.data) {
            this.analysisResultsStatus = response.data
            console.log('analysisResultsStatus', this.analysisResultsStatus)
          }
        })
        .catch(e => {
          console.log(e)
        })

      // Contact Status
      useJwt.axiosIns.post(`hotalert/analysis/contactstatus/${this.selectedProject}/${this.selectedPeriodStart}/${this.selectedPeriodEnd}`, this.appliedFilter)
        .then(response => {
          if (response.data) {
            this.analysisResultsContactStatus = response.data
            console.log('analysisResultsContactStatus', this.analysisResultsContactStatus)
          }
        })
        .catch(e => {
          console.log(e)
        })

      // Action Taken
      useJwt.axiosIns.post(`hotalert/analysis/action/${this.selectedProject}/${this.selectedPeriodStart}/${this.selectedPeriodEnd}`, this.appliedFilter)
        .then(response => {
          if (response.data) {
            this.analysisResultsAction = response.data
            console.log('analysisResultsAction', this.analysisResultsAction)
          }
        })
        .catch(e => {
          console.log(e)
        })

      // Categories
      useJwt.axiosIns.post(`hotalert/analysis/categories/${this.selectedProject}/${this.selectedPeriodStart}/${this.selectedPeriodEnd}`, this.appliedFilter)
        .then(response => {
          if (response.data) {
            this.analysisResultsCategories = response.data
            console.log('analysisResultsCategories', this.analysisResultsCategories)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    hotalertFilter() {
      this.filterConfig = JSON.parse(JSON.stringify(this.appliedFilter))
      this.$root.$emit('hotalert_filter', this.filterConfig)
    },
    setFilter(filter) {
      this.appliedFilter = JSON.parse(JSON.stringify(filter))
      this.loadData()
      this.loadAnalysis()
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
